<template>
  <a-config-provider size="small">
    <router-view v-if="isRouterAlive" />
  </a-config-provider>
</template>
<script>
  import { nextTick, provide, ref } from 'vue'
  export default {
    name: 'App',
    setup() {
      const isRouterAlive = ref(true)
      function reload() {
        isRouterAlive.value = false
        nextTick(() => (isRouterAlive.value = true))
      }
      provide('reload', reload)
      return {
        isRouterAlive,
      }
    },
  }
</script>
<style lang="less">
  @import '~@/assets/styles/hhxc.less';
  #app {
    height: 100%;
  }
</style>
